import Listener   from './Listener/index';
import Config     from './Config';
import dispatcher from './dispatcher';
import SLocker    from './SLocker';
import Helper     from './Helper';

import Input        from './components/Input';
import Main         from './components/Main';
import Sheet        from './components/Sheet';
import TimeSelector from './components/TimeSelector';
import DateSelector from './components/DateSelector';

(function() {
    class Calendar {
        constructor(element, opts) {
            this.opts = opts;
            this.instanceId = `calendar_${ Math.round(100000 - 0.5 + Math.random() * (999999 - 100000 + 1)) }`;
            this.dispatch = dispatcher.bind(this);

            this.config   = new Config(this, opts);
            this.listener = new Listener(this);
            this.sLocker  = new SLocker(this);
            this.helper   = new Helper(this);

            this.main  = new Main(this);
            this.input = new Input({ root: this, element });
            this.sheet = new Sheet(this);

            const config = this.config.get();

            if (config.type === 'datetime') {
                this.timeSelector = new TimeSelector(this);
            }

            if (config.showDateSelector) {
                this.dateSelector = new DateSelector(this);
            }

            // Run
            this.main.checkMobile();
            this.input.preBuild();
            this.listener.init();

            // Инпут уже в фокусе, показываем календарь
            if (!this.main.mobile && this.input.isFocused) {
                const ua = navigator.userAgent.toLowerCase();
                const isSafari = ua.indexOf('safari') !== -1 && ua.match(/version\/(\d+)/);

                // В сафари баг с фокусом, поэтому игнорируем и снимаем фокус, пусть юзер тычет снова
                if (isSafari) {
                    document.activeElement.blur();
                }
                else {
                    this.dispatch('showCalendar');
                }
            }
        }
    }

    // Define JQ plugin
    $.fn.calendar = function(opts) {
        const $elements = this.length && this;

        return $elements.each((index, element) => {
            const $element = $(element);
            const instance = new Calendar(element, opts);

            $element.data('calendar', instance);
        });
    };
}());
